export default __webpack_public_path__ + "static/media/annex14.72ed8fb6.png";